<template>
  <div>
    <router-link to="/admin/users"
      ><p style="cursor: pointer; margin-bottom: 10px">
        <u>Back to all users</u>
      </p></router-link
    >
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <h1 v-bg-typography="'h1'" v-if="!isLoading">
      {{ user.profile.first_name }} {{ user.profile.last_name }}
    </h1>
    <div class="form" style="margin-top: 50px" v-if="!isLoading">
      <div class="data">
        <bg-field class="field" label="First name" name="start">
          <bg-input v-model="user.profile.first_name" />
        </bg-field>
        <bg-field class="field" label="Last name" name="end">
          <bg-input v-model="user.profile.last_name" />
        </bg-field>
      </div>

      <div>
        <bg-field label="Company" name="email">
          <bg-select
            :options="companyOptions"
            :value="user.company"
            label="name"
            @change="onCompanyChange"
          ></bg-select>
        </bg-field>
      </div>

      <div>
        <bg-field label="Role" name="email">
          <bg-select
            :options="roleOptions"
            label="text"
            :value="selectedRole"
            @change="onRoleChange"
          ></bg-select>
        </bg-field>
      </div>

      <div>
        <bg-button
          variant="primary"
          text="Save"
          @click="saveUser"
          style="margin-bottom: 30px; margin-right: 20px"
        />
        <bg-button
          variant="secondary"
          text="Close"
          style="margin-bottom: 30px"
          @click="goBack()"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.form {
  max-width: 500px;
}
</style>

<script>
import API from "@/api";
import BgButton from "@/components/bg-button";
import BgField from "@/components/bg-field";
import BgLoader from "@/components/bg-loader";
import BgInput from "@/components/bg-input";
import BgTypography from "@/directives/bg-typography";
import BgSelect from "@/components/bg-select";

export default {
  components: {
    BgButton,
    BgField,
    BgButton,
    BgLoader,
    BgInput,
    BgSelect,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      companyOptions: [],
      isLoading: true,
      user: {},
      roleOptions: [
        {
          text: "Company Admin",
          value: "company_admin",
        },
        {
          text: "Company Member",
          value: "company_member",
        },
        {
          text: "Demo user",
          value: "demo",
        },
      ],
      selectedRole: "",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      this.user = await API.user.getUser(this.$route.params.id);
      this.selectedRole = this.roleOptions.find(
        (el) => el.value === this.user.role
      );

      if (this.$store.state.user.user.role === "admin") {
        this.roleOptions.push({
          text: "Braingineers employee",
          value: "admin",
        });
      }

      const data = await API.user.getCompanies();
      data.companies.forEach((el) => {
        this.companyOptions.push(el);
      });

      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const brandA = a.name.toUpperCase();
        const brandB = b.name.toUpperCase();

        let comparison = 0;
        if (brandA > brandB) {
          comparison = 1;
        } else if (brandA < brandB) {
          comparison = -1;
        }
        return comparison;
      }
      this.companyOptions.sort(compare);

      this.isLoading = false;
    },
    goBack() {
      this.$router.push("/admin/users");
    },
    onCompanyChange(val) {
      this.user.company_id = val.id;
      if (val.id === 1) {
        this.user.role = "demo";
      }
    },
    onRoleChange(val) {
      this.selectedRole = val;
      if (val === "demo") {
        this.user.company_id = 1;
      }
      this.user.role = this.selectedRole.value;
    },
    async saveUser() {
      this.isLoading = true;
      delete this.user.company;
      const res = await API.user.updateUser(this.$route.params.id, this.user);
      console.log(res);
      this.$router.push("/admin/users");
    },
  },
};
</script>
